export const HOME_REQUEST = 'HOME_REQUEST';
export const HOME_SUCCESS = 'HOME_SUCCESS';
export const HOME_FAIL = 'HOME_FAIL';
export const HOME_RESET = 'HOME_RESET';
